import React, { useEffect, useState } from "react";
import { FcBusinessman } from "react-icons/fc";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { useNavigate } from "react-router";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import DynamicFilterSelect from "../../../Kryzen Alpha App/Components/layouts/filter.select";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import { useSelector } from "react-redux";
import { IoIosArrowForward } from "react-icons/io";

const FarmerPartner = () => {
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [filters, setFilters] = useState({
    search: "",
    state: "",
    city: "",
    sortByDate: "",
  });

  const navigate = useNavigate();
  const store = useSelector((store) => store?.login?.user);
  const role = useSelector((store) => store?.login?.user);

  useEffect(() => {
    if (role && role.Role === process.env.REACT_APP_ROLE_CLIENT) {
      if (role.AdditionalRole !== "farmer partner") {
        navigate("/");
      }
    }
  }, [role, navigate]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL(
        "/pmg/farmer-partner/get-all-farmers-partners",
        page,
        filters
      )
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data || dummyData);
          setTotalPages(Math.ceil((res?.data?.count || 0) / 50));
        } else {
          Toast("error", "Error while getting farmer partners!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page]);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none mt-3 mb-2">
            <div className="row align-items-center">
              {/* Left Section */}
              <div className="col-md-6">
                <h2 className="page-title mb-1 d-flex align-items-center">
                  <FcBusinessman
                    className="fs-2 me-1"
                    style={{ color: "green" }}
                  />
                  Farmer Partners
                </h2>
                <h4 className="text-muted m-0">
                  Manage and view farmer partners.
                </h4>
              </div>

              {/* Right Section */}
              <div className="col-md-6 text-md-end mt-3 mt-md-0  d-flex justify-content-end gap-2">
                <div className="mr-2">
                  <button
                    className="btn btn-primary"
                    onClick={() =>
                      navigate("/farmer-partners/onboard-delivery-partner")
                    }
                  >
                    Onboard Delivery Partner
                    <IoIosArrowForward className="ms-2" />
                  </button>
                </div>

                <div>
                  <button
                    className="btn btn-primary "
                    onClick={() => navigate("/farmer-partners/onboard")}
                  >
                    Onboard Farmer Partner
                    <IoIosArrowForward className="ms-2" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* LEFT FILTER PANEL */}
            {/* <div className="col-12 text-end">
           
            </div> */}
            <div className="col-md-3 col-sm-12 mt-2 ">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    {/* MOBILE FILTER */}
                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12 mb-2">
                            <label className="form-label">Search</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search by name"
                              value={filters.search}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  search: e.target.value,
                                })
                              }
                            />
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="State:"
                              value={filters.state}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  state: e.target.value,
                                })
                              }
                            >
                              <option value="">Select</option>
                              <option value="maharashtra">Maharashtra</option>
                              <option value="gujarat">Gujarat</option>
                              <option value="rajasthan">Rajasthan</option>
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="City:"
                              value={filters.city}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  city: e.target.value,
                                })
                              }
                            >
                              <option value="">Select</option>
                              <option value="pune">Pune</option>
                              <option value="mumbai">Mumbai</option>
                              <option value="nagpur">Nagpur</option>
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Sort by Date:"
                              value={filters.sortByDate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  sortByDate: e.target.value,
                                })
                              }
                            >
                              <option value="">Select</option>
                              <option value="asc">Ascending</option>
                              <option value="desc">Descending</option>
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setPage(1);
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      search: "",
                                      state: "",
                                      city: "",
                                      sortByDate: "",
                                    });
                                    setPage(1);
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* DESKTOP FILTER */}
                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>

                        <div className="col-12 mb-2">
                          <label className="form-label">Search</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search by name"
                            value={filters.search}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                search: e.target.value,
                              })
                            }
                          />
                        </div>

                        <div className="col-12">
                          <DynamicFilterSelect
                            label="State:"
                            value={filters.state}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                state: e.target.value,
                              })
                            }
                          >
                            <option value="">Select</option>
                            <option value="maharashtra">Maharashtra</option>
                            <option value="gujarat">Gujarat</option>
                            <option value="rajasthan">Rajasthan</option>
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <DynamicFilterSelect
                            label="City:"
                            value={filters.city}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                city: e.target.value,
                              })
                            }
                          >
                            <option value="">Select</option>
                            <option value="pune">Pune</option>
                            <option value="mumbai">Mumbai</option>
                            <option value="nagpur">Nagpur</option>
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Sort by Date:"
                            value={filters.sortByDate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                sortByDate: e.target.value,
                              })
                            }
                          >
                            <option value="">Select</option>
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setPage(1);
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    search: "",
                                    state: "",
                                    city: "",
                                    sortByDate: "",
                                  });
                                  setPage(1);
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT CARD PANEL */}
            <div className="col-md-9 col-sm-12 mt-2">
              <div className="card p-3">
                <div className="row g-3">
                  {data?.length > 0 ? (
                    data.map((item, index) => (
                      <div
                        className="col-lg-3 col-md-4 col-sm-6 col-12"
                        key={item?.id || index}
                      >
                        <div className="card h-100 shadow-sm border">
                          <div className="card-body text-center">
                            <img
                              src={
                                item?.profileImage ||
                                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTabOgeMNrSqYJ4c2-kMg0I_QreIqbVVfgvWQ&s"
                              }
                              alt={item?.farmPartnerName || "Farmer Partner"}
                              className="rounded-circle mb-2 border border-1 "
                              style={{
                                width: "70px",
                                height: "70px",
                                objectFit: "contain",
                              }}
                            />
                            <h5 className="mb-1">
                              {item?.farmPartnerName || "N/A"}
                            </h5>
                            <p className="text-muted mb-1">
                              {item?.contactNumber || "No Contact"}
                            </p>
                            <p className="text-muted mb-1">
                              {item?.city || "No City"}
                            </p>
                            <p className="text-muted mb-0">
                              {item?.state || "No State"}
                            </p>
                          </div>
                          <div className="footer  col align-content-between p-2">
                            <button
                              onClick={() =>
                                navigate(`/farmer-epg-dashboard/${item?.id}`)
                              }
                              className="fs-5 outline-primary border bg-white  border-1 border-primary text-primary rounded-2 p-2"
                            >
                              Dashboard
                            </button>
                            <button
                              onClick={() =>
                                navigate(`/farmer-partners/view/${item?.id}`)
                              }
                              className="fs-5 outline-primary border bg-white  border-1 border-primary text-primary rounded-2 p-2 ms-4"
                            >
                              View Profile
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-12 text-center py-5">
                      <h4 className="text-muted">No farmer partners found</h4>
                    </div>
                  )}
                </div>

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FarmerPartner;

const dummyData = [
  {
    id: 1,
    userName: "Ramesh Patil",
    contactNumber: "9876543210",
    city: "Pune",
    state: "Maharashtra",
    profileImage: "https://via.placeholder.com/80",
    village: "Shirur",
    email: "ramesh.patil@example.com",
    joiningDate: "2026-01-10",
    status: "active",
  },
  {
    id: 2,
    userName: "Suresh Jadhav",
    contactNumber: "9876543211",
    city: "Nashik",
    state: "Maharashtra",
    profileImage: "https://via.placeholder.com/80",
    village: "Sinnar",
    email: "suresh.jadhav@example.com",
    joiningDate: "2026-01-12",
    status: "active",
  },
  {
    id: 3,
    userName: "Mahesh Shinde",
    contactNumber: "9876543212",
    city: "Kolhapur",
    state: "Maharashtra",
    profileImage: "https://via.placeholder.com/80",
    village: "Karveer",
    email: "mahesh.shinde@example.com",
    joiningDate: "2026-01-14",
    status: "inactive",
  },
  {
    id: 4,
    userName: "Ganesh More",
    contactNumber: "9876543213",
    city: "Satara",
    state: "Maharashtra",
    profileImage: "https://via.placeholder.com/80",
    village: "Wai",
    email: "ganesh.more@example.com",
    joiningDate: "2026-01-16",
    status: "active",
  },
  {
    id: 5,
    userName: "Vikas Chavan",
    contactNumber: "9876543214",
    city: "Ahmednagar",
    state: "Maharashtra",
    profileImage: "https://via.placeholder.com/80",
    village: "Rahata",
    email: "vikas.chavan@example.com",
    joiningDate: "2026-01-18",
    status: "active",
  },
  {
    id: 6,
    userName: "Sunil Pawar",
    contactNumber: "9876543215",
    city: "Aurangabad",
    state: "Maharashtra",
    profileImage: "https://via.placeholder.com/80",
    village: "Paithan",
    email: "sunil.pawar@example.com",
    joiningDate: "2026-01-20",
    status: "inactive",
  },
  {
    id: 7,
    userName: "Ajit Deshmukh",
    contactNumber: "9876543216",
    city: "Nagpur",
    state: "Maharashtra",
    profileImage: "https://via.placeholder.com/80",
    village: "Katol",
    email: "ajit.deshmukh@example.com",
    joiningDate: "2026-01-22",
    status: "active",
  },
  {
    id: 8,
    userName: "Prakash Wagh",
    contactNumber: "9876543217",
    city: "Amravati",
    state: "Maharashtra",
    profileImage: "https://via.placeholder.com/80",
    village: "Achalpur",
    email: "prakash.wagh@example.com",
    joiningDate: "2026-01-24",
    status: "active",
  },
  {
    id: 9,
    userName: "Nitin Kale",
    contactNumber: "9876543218",
    city: "Solapur",
    state: "Maharashtra",
    profileImage: "https://via.placeholder.com/80",
    village: "Pandharpur",
    email: "nitin.kale@example.com",
    joiningDate: "2026-01-25",
    status: "inactive",
  },
  {
    id: 10,
    userName: "Santosh Gaikwad",
    contactNumber: "9876543219",
    city: "Sangli",
    state: "Maharashtra",
    profileImage: "https://via.placeholder.com/80",
    village: "Miraj",
    email: "santosh.gaikwad@example.com",
    joiningDate: "2026-01-26",
    status: "active",
  },
  {
    id: 11,
    userName: "Rahul Mane",
    contactNumber: "9876543220",
    city: "Pune",
    state: "Maharashtra",
    profileImage: "https://via.placeholder.com/80",
    village: "Baramati",
    email: "rahul.mane@example.com",
    joiningDate: "2026-01-27",
    status: "active",
  },
  {
    id: 12,
    userName: "Deepak Bhosale",
    contactNumber: "9876543221",
    city: "Mumbai",
    state: "Maharashtra",
    profileImage: "https://via.placeholder.com/80",
    village: "Panvel",
    email: "deepak.bhosale@example.com",
    joiningDate: "2026-01-28",
    status: "inactive",
  },
];
